import React, { useState, useEffect, useMemo, useCallback } from "react";
import { logEventos } from "../../../../services/services";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { Box, Button, Container, Divider, ListItemIcon, MenuItem } from "@mui/material";
import { Edit as EditIcon, FindInPage as FindInPageIcon, Assignment as AssignmentIcon, People as PeopleIcon, AddBoxTwoTone as AddBoxTwoToneIcon, AccountCircle, AccountBalance, RequestQuote } from "@mui/icons-material";
import { UrlApi, UrlPortalProveedores } from "../../../../services/apirest";
import Navbar from "../../../Navbar";
import EditarGranProveedor from "./EditarGranProveedor";
import EditarPequeñoProveedor from "../pequeños_proveedores/abm/EditarPequeñoProveedor";
import FichaProveedor from "./FichaProveedor";

export default function Listado(params) {
    const [proveedores, setProveedores] = useState([]);
    const [row, setRow] = useState(null);
    const [showFormGranProveedor, setShowFormGranProveedor] = useState(false);
    const [showFormPequeñoProveedor, setShowFormPequeñoProveedor] = useState(false);
    const [showTabla, setShowTabla] = useState(true);
    const [ficha, setFicha] = useState(false);
    const [proveedorSeleccionado, setProveedorSeleccionado] = useState(null);

    const handleEditarProveedor = (row) => {
        setFicha(false);
        setProveedorSeleccionado(null);
        setRow(row);
        setShowTabla(false);
        if (Boolean(row?.pequeno)) {
            setShowFormPequeñoProveedor(true);
            setShowFormGranProveedor(false);
        } else {
            setShowFormGranProveedor(true);
            setShowFormPequeñoProveedor(false);
        }
    }

    const handleVerDetalle = useCallback((proveedor) => {
        setShowFormGranProveedor(false);
        setShowFormPequeñoProveedor(false);
        setRow(null);
        setProveedorSeleccionado(proveedor);
        setFicha(true);
        setShowTabla(false);
    }, []);

    const esColumnaAcciones = (columnId) =>
        columnId === "mrt-row-actions" || columnId === "actions";

    const abrirDetalleDesdeEvento = useCallback(
        (proveedor, event) => {
            const target = event?.target;
            if (
                target?.closest?.(
                    "button, a, input, textarea, select, [role='button'], .MuiMenuItem-root, .MuiIconButton-root"
                )
            ) {
                return;
            }
            handleVerDetalle(proveedor);
        },
        [handleVerDetalle]
    );

    const handleCerrarFicha = () => {
        setFicha(false);
        setShowTabla(true);
        setProveedorSeleccionado(null);
        setShowFormGranProveedor(false);
        setShowFormPequeñoProveedor(false);
    };

    const getProveedores = () => {
        fetch(UrlApi + '/proveedores/activos')
            .then((data) => data.json())
            .then((data) => setProveedores(data))
    };

    useEffect(() => {
        getProveedores()
    }, [])

    const muiSearchTextFieldProps = {
        placeholder: "Buscar..",
        sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
        variant: "outlined",
        color: "primary",
        size: "small",
    };

    const initialState = {
        density: "compact",
        showGlobalFilter: true,
        pagination: {
            pageSize: 10,
            pageIndex: 0,
        },
    };

    const tableHeadCellProps = {
        align: "left",
        sx: {
            fontSize: 16,
            color: "white",
            fontWeight: "normal",
            backgroundColor: "#2471A3",
            borderColor: "black",
        },
    };


    const columns = useMemo(
        () => [
            { header: "#", accessorKey: "sisven_id", size: 50, enableColumnActions: false, },
            { header: "Razon Social", accessorKey: "razon_social" },
            { header: "CUIT", accessorKey: "nro_cuit" },
            // {
            //     accessorKey: "inactivo",
            //     header: "Estado",
            //     size: 100,
            //     // Cell: ({ cell }) => (
            //     //     <Box
            //     //         component="span"
            //     //         sx={{
            //     //             backgroundColor:
            //     //                 cell.getValue() === 0 ? "#e6f4ea" : cell.getValue() === 1 ? "#fce8e6" : "#fff8e1",
            //     //             borderRadius: "4px",
            //     //             color: cell.getValue() === 0 ? "#137333" : cell.getValue() === 1 ? "#c5221f" : "#e37400",
            //     //             padding: "4px 8px",
            //     //             fontWeight: "bold",
            //     //         }}
            //     //     >
            //     //         {cell.getValue() === 0 ? "Activo" : "Inactivo"}
            //     //     </Box>
            //     // ),
            // },
        ],
        []
    );

    useEffect(() => {
        logEventos(
            "acceso al menú  Proveedores",
            "Tablas Referencias",
            "Proveedores",
            localStorage.getItem("user"));
    }, []);

    return (
        <div>
            <Navbar />
            <Container disableGutters maxWidth="xl">
                {showTabla && (
                    <Box mt={2} boxShadow={3} mb={5}>
                        <MaterialReactTable
                            columns={columns}
                            enableColumnResizing
                            data={proveedores}
                            initialState={initialState}
                            localization={MRT_Localization_ES}
                            muiSearchTextFieldProps={muiSearchTextFieldProps}
                            muiTableHeadCellProps={tableHeadCellProps}
                            muiTableBodyCellProps={({ row, cell }) => ({
                                align: "left",
                                onClick: (event) =>
                                    abrirDetalleDesdeEvento(row.original, event),
                                sx: {
                                    backgroundColor:
                                        row.original.inactivo === 0 ? "#b3e6b3" : "#efc3c3",
                                    color: "black",
                                    borderColor: "black",
                                    cursor: esColumnaAcciones(cell.column.id)
                                        ? "default"
                                        : "pointer",
                                },
                            })}
                            muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) =>
                                    abrirDetalleDesdeEvento(row.original, event),
                                sx: { cursor: "pointer" },
                            })}
                            displayColumnDefOptions={{
                                "mrt-row-actions": {
                                    muiTableBodyCellProps: {
                                        onClick: (event) => event.stopPropagation(),
                                    },
                                },
                            }}
                            enableExpandAll={false}
                            // enableGlobalFilter={true}
                            enableToolbarInternalActions={true}
                            layoutMode="grid"
                            enableColumnActions={false}
                            enableColumnFilters={false} //desactiva filtros x  columna
                            enableHiding={false}
                            enableDensityToggle={false} //
                            enableColumnDragging={false} //No permite que se arrastren las columnas.
                            enableStickyFooter
                            enableRowActions
                            positionActionsColumn="last"
                            // enableGlobalFilterModes={true}
                            // enableStickyHeader
                            enableGlobalFilter={true}
                            enableFullScreenToggle={false}
                            renderTopToolbarCustomActions={() => (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<AddBoxTwoToneIcon />}
                                    component="a"
                                    href={UrlPortalProveedores}
                                    target="_blank"
                                    rel="noopener noreferrer"

                                >
                                    Agregar Nuevo
                                </Button>
                            )}
                            renderRowActionMenuItems={({ closeMenu, row }) => [
                                <MenuItem
                                    key="Ver"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleVerDetalle(row.original);
                                        closeMenu();
                                    }}
                                >
                                    <ListItemIcon>
                                        <FindInPageIcon color="primary" />
                                    </ListItemIcon>
                                    Ver detalle
                                </MenuItem>,
                                <MenuItem
                                    key="Editar"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleEditarProveedor(row.original);
                                        closeMenu();
                                    }}
                                >
                                    <ListItemIcon>
                                        <EditIcon color="primary" />
                                    </ListItemIcon>
                                    Editar
                                </MenuItem>,
                                // <Divider key="divider" />,
                                /*   <MenuItem
                                  key="Ver"
                                  onClick={() => {
                                    handleVer(row.original.id);
                                    closeMenu();
                                  }}
                                >
                                  <ListItemIcon>
                                    <FindInPageIcon color="primary" />
                                  </ListItemIcon>
                                  Ver detalles
                                </MenuItem>,
                                  <Divider key="divider" />, */
                                // <MenuItem
                                //     key="Documentos"
                                //     onClick={() => {
                                //         // handleDocumentos(row.original.id);
                                //         closeMenu();
                                //     }}
                                // >
                                //     <ListItemIcon>
                                //         <AssignmentIcon color="primary" />
                                //     </ListItemIcon>
                                //     Documentos
                                // </MenuItem>,

                                // <MenuItem
                                //     key="Imputaciones"
                                //     onClick={() => {
                                //         // handleImputaciones(row.original.id);
                                //         closeMenu();
                                //     }}
                                // >
                                //     <ListItemIcon>
                                //         <AccountBalance color="secondary" />
                                //     </ListItemIcon>
                                //     Imputaciones
                                // </MenuItem>,

                                // <MenuItem
                                //     key="IIBB"
                                //     onClick={() => {
                                //         // handleIIBB(row.original.id);
                                //         closeMenu();
                                //     }}
                                // >
                                //     <ListItemIcon>
                                //         <RequestQuote color="warning" />
                                //     </ListItemIcon>
                                //     IIBB
                                // </MenuItem>,
                            ]}
                        />
                    </Box>
                )}
                {ficha && proveedorSeleccionado && !showTabla ? (
                    <Box mt={2} mb={5}>
                        <FichaProveedor
                            proveedor={proveedorSeleccionado}
                            onClose={handleCerrarFicha}
                        />
                    </Box>
                ) : null}
                {showFormGranProveedor &&
                 <EditarGranProveedor
                  row={row}
                  setRow={setRow}
                  open={showFormGranProveedor}
                  setopen={setShowFormGranProveedor}
                  settabla={setShowTabla}
                  actualizar={getProveedores} />}
                {showFormPequeñoProveedor && <EditarPequeñoProveedor row={row} />}
            </Container>
        </div>
    )
}